/** */
import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut } from 'services/_http';

/** */
const base_url = `${urls.iam}/users`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const deactivate = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/deactivate`, { ...options });
};

export const updateById = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const search = async (keys, keyword, options = {}) => {
  const query_string = options.query_string
    ? `${options.query_string}&keyword=${keyword}`
    : `keyword=${keyword}`;
  return await apiGet(`${base_url}/search/${keys}`, {
    ...options,
    query_string
  });
};
